import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";

const selectDomain = (state: any) => state.reportState || initialState;

export const reportListSelector = createSelector(
  selectDomain,
  (state) => state.reportList
);
